function redirectUser(userType) {
  const pathUserType = {
    admin: "/folders",
    employee: "/folders",
    superuser: "/clients",
  }
  if (userType) {
    return pathUserType[userType]
  }
  return "/login"
}
export default redirectUser
